<template>
  <v-layout row wrap>
    <v-flex xs12 d-flex
      ref="colorpicker"
    >
      <v-layout row wrap>
        <v-flex>
          <v-text-field
            v-model="color"
            @focus="showPicker()"
            @input="updateFromInput"
            :name="name"
            :label="label"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-btn
            color="accent"
            @click="togglePicker()"
            block
            outline
          >{{$tc('design.color', 1)}}</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <chrome-picker
      v-show="displayPicker"
      :value="colors"
      @input="updateFromPicker"
    />
  </v-layout>
</template>

<script>
import Chrome from 'vue-color/src/components/Chrome.vue';

export default {
  components: {
    'chrome-picker': Chrome,
  },
  props: {
    colorType: {
      type: String,
    },
    label: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  computed: {
    activeWidgetID: {
      get() {
        return this.$store.getters.getActiveWidget;
      },
    },
    color: {
      get() {
        return this.$store.getters[`widget${this.activeWidgetID}/getItem`].style[this.colorType];
      },
      set(value) {
        const payload = {
          data: [
            {
              path: 'style',
              key: this.colorType,
              value,
            },
          ],
        };

        this.$store.dispatch(`widget${this.activeWidgetID}/UPDATE_WIDGET`, payload);
      },
    },
  },
  data() {
    return {
      colors: {
        hex: '#FFFFFF',
      },
      colorValue: '',
      displayPicker: false,
    };
  },
  methods: {
    /* eslint-disable no-bitwise */
    updateColors(color) {
      if (color.slice(0, 1) === '#') {
        this.colors = {
          hex: color,
        };
      } else if (color.slice(0, 4) === 'rgba') {
        const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
        const hex = `#${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))}`.toString(16).slice(1);

        this.colors = {
          hex,
          a: rgba[3],
        };
      }
    },
    /* eslint-enable */
    showPicker() {
      this.displayPicker = true;
    },
    hidePicker() {
      this.displayPicker = false;
    },
    /* eslint-disable no-unused-expressions */
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    /* eslint-enable */
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;

      if (color.rgba.a === 1) {
        this.colorValue = color.hex;
        this.color = color.hex;
      } else {
        this.colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
        this.color = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
      }
    },
  },
  watch: {
    color(val) {
      if (val) {
        this.updateColors(val);
        this.$emit('input', val);
      }
    },
  },
};
</script>

<style>
.vc-chrome {
  width: 100% !important;
}
</style>
